/* tslint:disable */
/* eslint-disable */
/**
 * All APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SubscriptionUserInfo
 */
export interface SubscriptionUserInfo {
    /**
     * 
     * @type {string}
     * @memberof SubscriptionUserInfo
     */
    name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SubscriptionUserInfo
     */
    phoneNumber?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SubscriptionUserInfo
     */
    mlsId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SubscriptionUserInfo
     */
    officeName?: string | null;
}

/**
 * Check if a given object implements the SubscriptionUserInfo interface.
 */
export function instanceOfSubscriptionUserInfo(value: object): value is SubscriptionUserInfo {
    return true;
}

export function SubscriptionUserInfoFromJSON(json: any): SubscriptionUserInfo {
    return SubscriptionUserInfoFromJSONTyped(json, false);
}

export function SubscriptionUserInfoFromJSONTyped(json: any, ignoreDiscriminator: boolean): SubscriptionUserInfo {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'] == null ? undefined : json['name'],
        'phoneNumber': json['phoneNumber'] == null ? undefined : json['phoneNumber'],
        'mlsId': json['mlsId'] == null ? undefined : json['mlsId'],
        'officeName': json['officeName'] == null ? undefined : json['officeName'],
    };
}

export function SubscriptionUserInfoToJSON(json: any): SubscriptionUserInfo {
    return SubscriptionUserInfoToJSONTyped(json, false);
}

export function SubscriptionUserInfoToJSONTyped(value?: SubscriptionUserInfo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'phoneNumber': value['phoneNumber'],
        'mlsId': value['mlsId'],
        'officeName': value['officeName'],
    };
}

